class StickyProVariantSelect extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onStickyVariantChange);
  }

  onStickyVariantChange() {
    this.varOptions = this.querySelector("select");
    //console.log("connected", this.varOptions.value);

    let productForms = document.querySelector(
      `#product-sticky-form-${this.dataset.section}`
    );
    let input = productForms.querySelector('input[name="id"]');
    input.value = this.varOptions.value;
  }
}
customElements.define("sticky-variant-select", StickyProVariantSelect);

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) => {
    stickyScroll();
  });
  document.addEventListener("shopify:section:select", (event) => {
    stickyScroll();
  });
  document.addEventListener("shopify:section:deselect", (event) => {
    stickyScroll();
  });
}

const syncQuantityInputs = () => {
  const mainQuantityInput = document.querySelector('.product-form:not(.product__sticky .product-form) input[name="quantity"]');
  const stickyQuantityInput = document.querySelector('.product__sticky input[name="quantity"]');

  if (!mainQuantityInput || !stickyQuantityInput) return;

  // Sync sticky -> main
  ['change', 'input'].forEach((eventType) => {
    stickyQuantityInput.addEventListener(eventType, () => {
      mainQuantityInput.value = stickyQuantityInput.value;
      // Trigger event on main input to update tiered pricing
      mainQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
    });
  });

  // Sync main -> sticky
  ['change', 'input'].forEach((eventType) => {
    mainQuantityInput.addEventListener(eventType, () => {
      stickyQuantityInput.value = mainQuantityInput.value;
    });
  });
};

const stickyScroll = () => {
  let stickySelectedVariant = document.querySelector(`#sticky__variant`);
  if (stickySelectedVariant) {
    let stickySelectVairantInput = document.querySelector(
      "#sticky__selected_variant_id"
    );
    stickySelectVairantInput.value = stickySelectedVariant.value;
  }

  const BuyButtonForm = document.querySelector(".product_buy_button_form");
  const productStickyWrapper = document.querySelector(".product__sticky");

  const isMobile = () => window.innerWidth < 768;

  const updateStickyState = () => {
    document.documentElement.style.setProperty(
      "--sticky-bar-height",
      `${productStickyWrapper.clientHeight}px`
    );

    if (isMobile()) {
      productStickyWrapper.classList.add("sticky");
      document.body.classList.add("sticky__cart");
      return;
    }

    let BuyBUttonOffset = TopOffset(BuyButtonForm);
    let BuyBUttonTopffset = BuyBUttonOffset.top;

    if (window.scrollY > BuyBUttonTopffset) {
      productStickyWrapper.classList.add("sticky");
      document.body.classList.add("sticky__cart");
    } else {
      productStickyWrapper.classList.remove("sticky");
      document.body.classList.remove("sticky__cart");
    }
  };

  updateStickyState();
  window.addEventListener("scroll", updateStickyState);
  window.addEventListener("resize", updateStickyState);
};

syncQuantityInputs();
stickyScroll();
